import React from "react";
import styles from "./ProgressBar.module.scss";
import { useSelector } from "react-redux";

const ProgressBar = () => {
  const completedstages = useSelector(
    (state: any) => state.PATHNAME.completedstages,
  );

  return (
    <div className={styles.progressWrapper}>
      <div
        className={styles.progressBar}
        style={{
          width: `${completedstages?.length * 12 || "20"}%`,
        }}
      ></div>
    </div>
  );
};

export default ProgressBar;
